/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Chat_S1Inputs */

const en_mk_tut_chat_s1 = /** @type {(inputs: Mk_Tut_Chat_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open one of the channels under a division name, \`#weekly-promo\` for instance, and write a message as usual.`)
};

const id_mk_tut_chat_s1 = /** @type {(inputs: Mk_Tut_Chat_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka salah satu channel di bawah nama divisi, misalnya \`#promo-mingguan\`, lalu tulis pesan seperti biasa.`)
};

/**
* | output |
* | --- |
* | "Open one of the channels under a division name, `#weekly-promo` for instance, and write a message as usual." |
*
* @param {Mk_Tut_Chat_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chat_s1 = /** @type {((inputs?: Mk_Tut_Chat_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Chat_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chat_s1(inputs)
	return en_mk_tut_chat_s1(inputs)
});